import { useMyHubsList } from "hooks";
import PropTypes from "prop-types";
import React, { useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import "./HubFilter.scss";

const HubFilter = props => {
  const {
    mainFilterParams,
    setMainFilterParams,
    isForOrder = false,
    handleChangeHub,
    handleSelectHub,
    isNotFilterChildHub = false,
    isHaveAllOption = false,
    isFilterAllDefault = false,
    label,
    isHidden = false,
    queryKey = "",
    keyFilterIn = null,
    addressLevel,
    isCompact = false,
  } = props;

  const ALL_OPTIONS = {
    name: "Tất cả",
    id: "all",
  };
  const [isHubFilter, setIsHubFilter] = useState(false);
  const [hubsFilter, setHubsFilter] = useState([]);
  const [selectedHubFilter, setSelectedHubFilter] = useState("");

  const handleSelectHubFilter = hub => {
    handleChangeHub && handleChangeHub();
    const { childs_hub } = hub;
    const columnFilterKeep = { ...mainFilterParams.columnFilterKeep };
    setIsHubFilter(false);
    if (hub.id) {
      setSelectedHubFilter(hub.name);
      let idsFilter = [hub.id];
      if (
        childs_hub &&
        (!isNotFilterChildHub || hub.name === ALL_OPTIONS.name)
      ) {
        idsFilter = [...idsFilter, ...childs_hub?.map(c => c.id)];
      }
      if (hub.id === ALL_OPTIONS.id) {
        idsFilter = [
          hubsFilter?.filter(h => h.id !== ALL_OPTIONS.id).map(h => h?.id),
        ];
      }
      if (isForOrder) {
        columnFilterKeep["hub_id"] = idsFilter.join(",");
      } else {
        if (keyFilterIn) {
          columnFilterKeep[keyFilterIn] = idsFilter?.join(",");
        } else {
          columnFilterKeep["hub_ids"] = idsFilter.join(",");
        }
      }
      const isSelectAll = isHaveAllOption && hub.name === ALL_OPTIONS.name;
      handleSelectHub && handleSelectHub(idsFilter, isSelectAll, hub);
    } else {
      setSelectedHubFilter("");
      if (isForOrder) {
        delete columnFilterKeep["hub_id"];
      } else {
        if (keyFilterIn) {
          delete columnFilterKeep[keyFilterIn];
        } else {
          delete columnFilterKeep["hub_ids"];
        }
      }
    }
    setMainFilterParams(prev => ({
      ...prev,
      page: 1,
      columnFilterKeep,
      columnFilter: {
        ...prev.columnFilter,
        ...columnFilterKeep,
      },
    }));
  };

  const { data: hubs, refetch: refetchHubs } = useMyHubsList(
    {
      enabled: true,
      queryKey: `${queryKey}-hub-filter`,
      params: {
        // Bỏ is_new_address filter
      },
    },
    res => {
      const { childs_hub, hub, parent_hub } = res;

      let hubFilter_ = [];

      if (hub) {
        hubFilter_.push({
          ...hub,
          childs_hub: childs_hub || [],
        });
      }

      // Thêm child hubs
      hubFilter_ = [...hubFilter_, ...(childs_hub || [])];

      if (isHaveAllOption && hubFilter_.length > 0) {
        hubFilter_.unshift({
          ...ALL_OPTIONS,
          id: ALL_OPTIONS.id,
          childs_hub: childs_hub || [],
        });
      }

      setHubsFilter(hubFilter_);

      // Set default hub filter
      const defaultHubFilter = hub || childs_hub?.[0];
      const defaultFilterIds = defaultHubFilter
        ? isNotFilterChildHub && !isFilterAllDefault
          ? [defaultHubFilter?.id]
          : [defaultHubFilter?.id, ...(childs_hub || []).map(c => c.id)]
        : [];

      const isSelectAll = isHaveAllOption && isFilterAllDefault;
      handleSelectHub &&
        handleSelectHub(defaultFilterIds, isSelectAll, defaultHubFilter);

      if (defaultHubFilter) {
        if (isForOrder) {
          setMainFilterParams(prev => ({
            ...prev,
            page: 1,
            columnFilterKeep: {
              ...prev.columnFilterKeep,
              hub_id: defaultFilterIds?.join(","),
            },
            columnFilter: {
              ...prev.columnFilterKeep,
              ...prev.columnFilter,
              hub_id: defaultFilterIds?.join(","),
            },
            run: true,
          }));
        } else {
          if (keyFilterIn) {
            setMainFilterParams(prev => ({
              ...prev,
              page: 1,
              columnFilterKeep: {
                ...prev.columnFilterKeep,
                [keyFilterIn]: defaultFilterIds?.join(","),
              },
              columnFilter: {
                ...prev.columnFilterKeep,
                ...prev.columnFilter,
                [keyFilterIn]: defaultFilterIds?.join(","),
              },
              run: true,
            }));
          } else {
            setMainFilterParams(prev => ({
              ...prev,
              page: 1,
              columnFilterKeep: {
                ...prev.columnFilterKeep,
                hub_ids: defaultFilterIds.join(","),
              },
              columnFilter: {
                ...prev.columnFilterKeep,
                ...prev.columnFilter,
                hub_ids: defaultFilterIds.join(","),
              },
              run: true,
            }));
          }
        }
        setSelectedHubFilter(
          isFilterAllDefault ? ALL_OPTIONS.name : defaultHubFilter?.name
        );
      } else {
        setSelectedHubFilter("");
      }
    }
  );

  // useEffect(() => {
  //   if (addressLevel) {
  //     setHubsFilter([]);
  //     setSelectedHubFilter("");
  //     refetchHubs();
  //   }
  // }, [addressLevel, refetchHubs]);

  // useEffect(() => {
  //   if (!Array.isArray(hubs) || hubs.length === 0 || !addressLevel) return;
  //   if (hubs?.length > 0) {
  //     const defaultHub = hubs[0];
  //     if (!defaultHub?.id) return;

  //     setMainFilterParams(prev => ({
  //       ...prev,
  //       columnFilter: {
  //         ...prev.columnFilter,
  //         "filter[is_new_address]": addressLevel === 2 ? "N" : "O",
  //         "filter[hub_id]": defaultHub.id,
  //       },
  //       page: 1,
  //     }));
  //   }
  // }, [hubs, addressLevel, setMainFilterParams]);

  return (
    !isHidden && (
      <div className={`HubFilter${isCompact ? " HubFilter--compact" : ""}`}>
        <Dropdown
          isOpen={isHubFilter}
          toggle={() => setIsHubFilter(!isHubFilter)}
        >
          <DropdownToggle
            className={`btn primary-btn text-overflow${
              isCompact ? "" : " w-100"
            }`}
            caret
          >
            {label ? label : "Center/Hub"}
            {selectedHubFilter && <span>:&nbsp;{selectedHubFilter}</span>}
            <i className="mdi mdi-chevron-down" />
          </DropdownToggle>
          <DropdownMenu className={isCompact ? "" : "w-100"}>
            {hubsFilter?.map((hub, index) => (
              <DropdownItem
                key={`hub-${index}`}
                onClick={() => handleSelectHubFilter(hub)}
              >
                <div style={{ width: "max-content" }}>
                  {hub?.name} {`${hub?.is_center ? " (Center)" : ""}`}
                </div>
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
    )
  );
};

HubFilter.propTypes = {
  label: PropTypes.string,
  queryKey: PropTypes.any,
  isForOrder: PropTypes.any,
  mainFilterParams: PropTypes.any.isRequired,
  setMainFilterParams: PropTypes.any.isRequired,
  handleChangeHub: PropTypes.any,
  handleSelectHub: PropTypes.any,
  isNotFilterChildHub: PropTypes.any,
  isHaveAllOption: PropTypes.bool,
  isFilterAllDefault: PropTypes.bool,
  isHidden: PropTypes.bool,
  keyFilterIn: PropTypes.string,
  addressLevel: PropTypes.number,
  provinceCode: PropTypes.string,
  districtCode: PropTypes.string,
  isCompact: PropTypes.bool,
};

export default HubFilter;
